
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class IncomeTaxSlabsDialog extends _Ext.DialogBase<IncomeTaxSlabsRow, any> {
        protected getFormKey() { return IncomeTaxSlabsForm.formKey; }
        protected getIdProperty() { return IncomeTaxSlabsRow.idProperty; }
        protected getLocalTextPrefix() { return IncomeTaxSlabsRow.localTextPrefix; }
        protected getNameProperty() { return IncomeTaxSlabsRow.nameProperty; }
        protected getService() { return IncomeTaxSlabsService.baseUrl; }
        protected getDeletePermission() { return IncomeTaxSlabsRow.deletePermission; }
        protected getInsertPermission() { return IncomeTaxSlabsRow.insertPermission; }
        protected getUpdatePermission() { return IncomeTaxSlabsRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new IncomeTaxSlabsForm(this.idPrefix);

    }
}